import { Box, IconButton, Typography } from '@mui/material';
import IconReusable from '../../../../components/IconReusable';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  selectCurrentCartTotals,
  selectCurrentCart,
} from '../reducer/DpSelectors';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import { ShoppingCartFilled } from '../../../../components/icons';
import { toast } from 'react-toastify';
import { DP_ROUTE_SOURCE } from '../Enums';

const CartItem = ({ selectedCompanyData, source, }) => {
    const navigate = useNavigate();
    const currentCartTotals = useSelector(selectCurrentCartTotals);
    const cartItems = useSelector(selectCurrentCart);
    
    const totalQuantity = currentCartTotals?.total_quantity_in_metric_ton || 0;
    
    // Calculate quantity of only new items (not existing items)
    const newItemsQuantity = cartItems
        .filter(item => item.isExistingItem !== true)
        .reduce((total, item) => total + (item.quantity?.quantity_in_metric_ton || 0), 0);
    
    // Don't show red dot when coming from Order Summary (user intentionally adding products)
    const shouldShowRedDot = newItemsQuantity > 0
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', ml: { xs: 2.2, sm: 3 } }}>
        <IconButton
          onClick={() =>
              totalQuantity > 0 ?
              navigate('/dp-cart', {
                  state: {
                      selectedCompany: selectedCompanyData,
                      from: source,
                  },
              })
              : toast.error("Add Product to Proceed")
          }
          sx={{
            borderRadius: 1,
            cursor: 'pointer',
            position: 'relative',
            '&:hover': {
              backgroundColor: '#995A000D',
            },
          }}
        >
          <Typography variant="labelD" sx={{ color: '#995A00', mr: 1 }}>
            Cart
          </Typography>
          <IconReusable name="ShoppingCartFilled" color="#995A00" />

          {shouldShowRedDot && (
            <Box
              sx={{
                position: 'absolute',
                top: 2,
                right: 6,
                width: { xs: 7, md: 8 },
                height: { xs: 7, md: 8 },
                bgcolor: '#CC0000',
                borderRadius: '50%',
              }}
            />
          )}
        </IconButton>
      </Box>
    );
};

export default CartItem;
